import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Organization } from 'src/common/types/Organization';
import SnackbarUtils from 'src/common/utils/SnackbarUtilsConfigurator';

import { useDeleteOrganizationMutation } from '../../../../common/apis/AdminApi';
import { ReactComponent as CancelIconBlue } from '../../../../common/assets/icons/cancel_icon_blue.svg';

type Props = {
  organization: Organization;
  onClose: () => void;
};

const DeleteOrganizationPopup: React.FC<Props> = ({
  onClose,
  organization,
}) => {
  const [deleteOrganization, { isLoading }] = useDeleteOrganizationMutation();

  const submit = async () => {
    if (isLoading) return;
    deleteOrganization({
      id: organization.id.toString(),
    })
      .unwrap()
      .then((res) => {
        SnackbarUtils.success(res.message);
        onClose();
      });
  };

  if (!organization) return <></>;

  return (
    <Box
      sx={{
        maxWidth: '456px',
        minHeight: '274px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        borderRadius: '15px',
        padding: '40px',
        flexDirection: 'column',
      }}
    >
      <Box className='row' sx={{ alignItems: 'center' }}>
        <IconButton
          onClick={onClose}
          disabled={isLoading}
          sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
        >
          <CancelIconBlue />
        </IconButton>
        <Typography
          sx={{
            alignSelf: 'center',
            whiteSpace: 'break-spaces',
            textAlign: 'center',
            mb: '24px',
            ml: 'auto',
            mr: 'auto',
          }}
          color='text.primary'
          variant='h5'
        >
          Delete Organization
        </Typography>
        <Box sx={{ mr: 'auto' }} />
      </Box>
      <Box>
        <Typography sx={{ mt: 1 }} color={'secondary'} fontSize={18}>
          Keep in mind that the subscription will be cancelled and Stripe will
          try to charge the owner at the end of the billing cycle for what
          remains unpaid. Also, all of the user accounts within the organization
          will be converted back to individual users. The search results and OP
          Notes within the organization will also have no organization.
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button
          onClick={onClose}
          disableElevation
          color='appGray2'
          variant='contained'
          disabled={isLoading}
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel</Typography>
        </Button>
        <LoadingButton
          onClick={submit}
          loading={isLoading}
          color='error'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Delete</Typography>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default DeleteOrganizationPopup;
